import { useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'

import { userThunks } from 'store/features/user/thunks'
import { projectThunks } from 'store/features/project/thunks'
import { projectDataThunks } from 'store/features/projectData/thunks'
import { dispatch } from 'store'
import { NEW_PROJECT_ID_PARAM } from 'consts'
import { aiImageThunks } from 'store/features/aiImage/thunks'

export const useInitialFetch = () => {
  const { projectId = '' } = useParams()
  const navigate = useNavigate()

  useEffect(() => {
    dispatch(userThunks.initializeAppAuth())

    const isInvalidProjectId = isNaN(Number(projectId))
    const isNewProjectId = projectId === NEW_PROJECT_ID_PARAM
    dispatch(
      projectThunks.setIsNewProject(isInvalidProjectId || isNewProjectId)
    )

    if (projectId !== NEW_PROJECT_ID_PARAM) {
      if (isNaN(Number(projectId))) {
        navigate('/new', { replace: true })
        return
      }

      dispatch(projectThunks.getProject(projectId))
      dispatch(projectDataThunks.getProjectData(projectId))
    } else {
      dispatch(aiImageThunks.getStyles())
      dispatch(aiImageThunks.getRestylingStyles())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
